import type { ComponentType } from 'react';
import type { FieldComponentProps } from './types';
import { getYearlyDaysFromDate } from '../../utils/utils';
import TextField from '../inputs/TextField';
import NumberField from '../inputs/NumberField';
import ArrayField from '../inputs/ArrayField';
import SpecialArrayField from '../inputs/SpecialArrayField';
import CheckBoxField from '../inputs/CheckboxField';
import DateField from '../inputs/DateField';
import SelectField from '../inputs/SelectField';
import SpecialMultiSelect from '../inputs/SpecialMultiSelect';
import SoilingRatioMultiSelect from '../inputs/SoilingRatioMultiSelect';
import SwitchField from '../inputs/SwitchField';
import CallContent from '../inputs/CallContentField';
import UploadField from '../inputs/UploadField';
import MonthlyValuesField from '../inputs/MonthlyValuesField';
import ButtonGroupField from '../inputs/ButtonGroupField';

const ArrayFieldWithDays = ({ field }: FieldComponentProps) => <ArrayField field={field} getYearlyDaysFromDate={getYearlyDaysFromDate} />;

export const fieldRegistry: Record<string, ComponentType<FieldComponentProps>> = {
  text: TextField,
  number: NumberField,
  array: ArrayFieldWithDays,
  sarray: ArrayFieldWithDays,
  special_array: SpecialArrayField,
  checkbox: CheckBoxField,
  date: DateField,
  select: SelectField,
  multiSelectSpecial: SpecialMultiSelect,
  soilingRatioMultiSelect: SoilingRatioMultiSelect,
  switch: SwitchField,
  callContent: CallContent,
  upload: UploadField,
  monthlyValues: MonthlyValuesField,
  buttonGroup: ButtonGroupField,
};
